import * as Sentry from '@sentry/vue'

import type { DeliveryIdResponse } from '@layers/web/services/types/delivery-id-api.ts'
import { isManualAbortError, isTransientNetworkError } from '@layers/web/utils/error.ts'

export class DeliveryIdApiService {
  static async fetchEmailFromDeliveryId (deliveryId: string): Promise<string | null> {
    try {
      const { data } = await apiFetch<DeliveryIdResponse>('/did', {
        method: 'POST',
        body: { id: deliveryId },
      })
      return data?.email ?? null
    } catch (error: any) {
      if (isManualAbortError(error) || isTransientNetworkError(error)) {
        throw error
      }

      Sentry.setContext('details', error.data)
      Sentry.captureException(new Error('Failed to fetch email from delivery id'), {
        level: 'error',
        tags: {
          operation: 'fetchEmailFromDeliveryId',
          service: 'delivery-id-api',
        },
      })
      throw error
    }
  }
}
